import{f as t}from"./ninox-components-MYF6AQNE.js";import{a as e}from"./ninox-components-I2GBTDK4.js";import{c as n}from"./ninox-components-YAP3BY3K.js";import o from"styled-components";var i=o.button`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0;
    flex-shrink: 0;

    appearance: none;
    outline: none;
    border-style: solid;
    border-width: ${t.tiny};
    border-color: transparent;
    background-color: transparent;
    color: inherit;

    font-family: ${n.sans};
    font-size: inherit;
    font-weight: ${e.medium};
    line-height: 1;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    user-select: none;

    transition-duration: 150ms;
    transition-timing-function: ease;
    transition-property: all;

    &:disabled {
        cursor: default;
    }
`;i.defaultProps={type:"button"};export{i as a};
//# sourceMappingURL=ninox-components-4KWCCUJ4.js.map